import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Spinner } from "@/components/kit";
import { AREA_NAMES, BodyFigure } from "@/components/bodymap/BodyFigure";

const HEAT = "#E8A07A";

// 30-day "where stress shows up" view: soft glows sized by how often an area was mapped
export const BodyPatterns = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/body-map/patterns?days=30").then((r) => setD(r.data)).catch(() => setD({ total: 0, areas: {}, notes: [] })); }, []);
  if (!d) return <Spinner />;
  if (!d.total) return <div className="mm-card p-8 text-center text-mm-muted" data-testid="body-patterns-empty">Map how you feel a few times and your 30-day pattern will appear here.</div>;
  const max = Math.max(...Object.values(d.areas).map((a) => a.count));
  const fills = Object.fromEntries(Object.entries(d.areas).map(([k, a]) => [k, { color: HEAT, opacity: 0.2 + 0.6 * (a.count / max) }]));
  const ranked = Object.entries(d.areas).sort((a, b) => b[1].count - a[1].count);
  return (
    <div className="grid md:grid-cols-2 gap-6 items-start" data-testid="body-patterns">
      <div className="mm-card p-5">
        <div className="grid grid-cols-2 gap-2">
          <div><div className="text-center text-xs text-mm-muted mb-1">Front</div><BodyFigure side="front" fills={fills} testPrefix="heat" /></div>
          <div><div className="text-center text-xs text-mm-muted mb-1">Back</div><BodyFigure side="back" fills={fills} testPrefix="heat" /></div>
        </div>
        <p className="text-center text-xs text-mm-muted mt-3">Last 30 days · {d.total} map{d.total === 1 ? "" : "s"} · warmer glow = more often</p>
      </div>
      <div className="space-y-3">
        {d.notes.map((n) => <div key={n} className="mm-soft p-4 text-sm font-medium" data-testid="body-pattern-note">{n}</div>)}
        {!d.notes.length && <div className="mm-soft p-4 text-sm text-mm-muted" data-testid="body-pattern-notes-pending">After {d.min_for_notes} maps you'll see notes like "Your stomach often tightens on work days".</div>}
        <div className="mm-card p-4">
          {ranked.map(([k, a]) => (
            <div key={k} className="flex items-center justify-between py-2 border-b border-mm-line last:border-0 text-sm" data-testid={`body-pattern-row-${k}`}>
              <span className="font-semibold">{AREA_NAMES[k]}</span>
              <span className="text-mm-muted">{a.count}× · mostly {a.top_feeling} · avg {a.avg_intensity}/5</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
